export default __webpack_public_path__ + "static/media/menu_hamburger.1a1d6f02.svg";